export interface Event {
  id: string;
  title: string;
  description: string;
  eventDate: Date;
  startTime: string;
  endTime: string;
  location: string;
  locationAddress: string;
  imageUrl: string;
  price: number;
  priceType: 'free' | 'paid';
  category: 'workshop' | 'tasting' | 'live_music' | 'art_exhibition' | 'coffee_ceremony' | 'networking';
  maxAttendees?: number;
  currentAttendees: number;
  placeId?: string;
  placeName?: string;
  placeLogo?: string;
  cityId?: string;
  cityName?: string;
  organizer: string;
  organizerAvatar?: string;
  registrationUrl?: string;
  tags: string[];
  requirements?: string[];
  includes: string[];
  status: 'active' | 'cancelled' | 'finished';
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateEventDto {
  title: string;
  description: string;
  eventDate: string; // ISO string
  startTime: string; // HH:mm format
  endTime: string; // HH:mm format
  location: string;
  locationAddress: string;
  imageUrl: string;
  price: number;
  priceType: number; // 1 = Free, 2 = Paid
  category: number; // 1-6 based on enum
  maxAttendees?: number;
  organizer: string;
  organizerAvatar?: string;
  registrationUrl?: string;
  placeId?: string;
  cityId?: string;
  tags: string[];
  requirements?: string[];
  includes: string[];
}

export interface UpdateEventDto {
  id: string;
  title: string;
  description: string;
  eventDate: string; // ISO string
  startTime: string; // HH:mm format
  endTime: string; // HH:mm format
  location: string;
  locationAddress: string;
  imageUrl: string;
  price: number;
  priceType: number; // 1 = Free, 2 = Paid
  category: number; // 1-6 based on enum
  maxAttendees?: number;
  organizer: string;
  organizerAvatar?: string;
  registrationUrl?: string;
  placeId?: string;
  cityId?: string;
  tags: string[];
  requirements?: string[];
  includes: string[];
  status: number; // 1 = Active, 2 = Cancelled, 3 = Finished
}

export interface Place {
  id: string;
  name: string;
  logo?: string;
  address: string;
}

export const EVENT_CATEGORIES = [
  { value: 1, label: 'Workshop' },
  { value: 2, label: 'Tasting' },
  { value: 3, label: 'Live Music' },
  { value: 4, label: 'Art Exhibition' },
  { value: 5, label: 'Coffee Ceremony' },
  { value: 6, label: 'Networking' }
];

export const EVENT_PRICE_TYPES = [
  { value: 1, label: 'Gratuito' },
  { value: 2, label: 'Pago' }
];

export const EVENT_STATUSES = [
  { value: 1, label: 'Ativo' },
  { value: 2, label: 'Cancelado' },
  { value: 3, label: 'Finalizado' }
];
